/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSupportRequestRequest
 */
export interface CreateSupportRequestRequest {
    /**
     * 
     */
    firstname?: string;
    /**
     * 
     */
    lastname?: string;
    /**
     * 
     */
    company?: string;
    /**
     * 
     */
    email: string;
    /**
     * 
     */
    phone?: string;
    /**
     * 
     */
    message: string;
    /**
     * 
     */
    contactReason: string;
    /**
     * 
     */
    requestCallBack?: boolean;
    /**
     * 
     */
    priority?: string;
}

/**
 * Check if a given object implements the CreateSupportRequestRequest interface.
 */
export function instanceOfCreateSupportRequestRequest(value: object): value is CreateSupportRequestRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('contactReason' in value) || value['contactReason'] === undefined) return false;
    return true;
}

export function CreateSupportRequestRequestFromJSON(json: any): CreateSupportRequestRequest {
    return CreateSupportRequestRequestFromJSONTyped(json, false);
}

export function CreateSupportRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSupportRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'company': json['company'] == null ? undefined : json['company'],
        'email': json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'message': json['message'],
        'contactReason': json['contactReason'],
        'requestCallBack': json['requestCallBack'] == null ? undefined : json['requestCallBack'],
        'priority': json['priority'] == null ? undefined : json['priority'],
    };
}

export function CreateSupportRequestRequestToJSON(json: any): CreateSupportRequestRequest {
    return CreateSupportRequestRequestToJSONTyped(json, false);
}

export function CreateSupportRequestRequestToJSONTyped(value?: CreateSupportRequestRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'company': value['company'],
        'email': value['email'],
        'phone': value['phone'],
        'message': value['message'],
        'contactReason': value['contactReason'],
        'requestCallBack': value['requestCallBack'],
        'priority': value['priority'],
    };
}

